export default __webpack_public_path__ + "static/JohnGrossenbacher-e0a9fcbe0327d79f434ba0ce78fcd619.jpg";